import { inputClasses } from "@mui/material/Input";
export const InputBase = {
    MuiInputBase: {
        defaultProps: {},
        styleOverrides: {
            root: {
                [`&.${inputClasses.focused}`]: {}
            }
        }
    }
};

//# sourceMappingURL=InputBase.js.map